module.exports = __webpack_public_path__ + "static/profile-a156aeaf53a57979ae1a538c23bd62ea.png";